// extracted by mini-css-extract-plugin
export default {"search-btn":"search-btn--myExJ","search-btn__icon":"search-btn__icon--Yf79T"};